// Angular service

import { Injectable } from '@angular/core';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class PrintingService {
  constructor(private notificationService: NotificationService) {}
  print(content: string, styles: any) {
    this.initPopupBlocker();

    // Attempt to open the window off-screen
    const printWindow = window.open('', '_blank', 'width=1200,height=750');
    if (!printWindow) {
      this.notificationService.open(
        'Please allow pop-ups for this site to print the payment slip.',
        'error',
        { duration: 3000 }
      );
      return;
    }

    printWindow.document.write(`
        <html>
          <head>
            <title>Print tab</title>
            <base href="${document.baseURI}">
            ${styles}
            <style>
              html,
              body {
                height: auto !important;
                overflow: visible !important;
              }

              body {
                margin: 0;
              }

              .page-content,
              .mat-expansion-panel-content,
              .mat-expansion-panel-content-wrapper,
              .mat-expansion-panel-body {
                height: auto !important;
                max-height: none !important;
                overflow: visible !important;
              }

              .mat-expansion-panel-content {
                visibility: visible !important;
              }

              .mat-expansion-panel-content-wrapper {
                display: block !important;
              }

              .mat-expansion-panel-body {
                display: block !important;
              }

              @media print {
                .invisible,
                .hidden,
                [hidden],
                [aria-hidden='true'],
                .not-printable { display: none; }
              }
            </style>
          </head>
          <body>${content}</body>
        </html>`);
    printWindow.document.close();
    printWindow.focus();
    printWindow.onafterprint = () => printWindow.close();
    setTimeout(() => printWindow.print(), 300);
  }

  private initPopupBlocker() {
    const popupInitWindow = window.open(
      '',
      '_blank',
      'top=0,left=0,width=0,height=0'
    );
    popupInitWindow.close();
  }
}
